var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',[_c('add-update-resource-action',{ref:"resourceActionForm",attrs:{"resource-id":_vm.resourceId},on:{"create":_vm.onNewResourceAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }